import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonCircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="personCircleFilled" ref={ref} {...props}>
    <path d="M16,9.65a4,4,0,1,1-4-4A4,4,0,0,1,16,9.65ZM22.32,12A10.32,10.32,0,1,1,12,1.68,10.32,10.32,0,0,1,22.32,12Zm-1.5,0a5.8,5.8,0,0,0,0-.59A8.82,8.82,0,1,0,3.19,12a8.7,8.7,0,0,0,2.5,6.14,4.31,4.31,0,0,1,4.07-2.89h4.48a4.31,4.31,0,0,1,4.07,2.89h0A8.7,8.7,0,0,0,20.82,12Z" />
  </Icon>
)) as IconWithRender;

PersonCircleFilledIcon.displayName = 'PersonCircleFilledIcon';
PersonCircleFilledIcon.renderIcon = (props) => (
  <PersonCircleFilledIcon {...props} />
);
export default PersonCircleFilledIcon;
